
import axios from 'axios';
import { handleApiError } from "../Vendor/vendoreffect";
import { getDecryptedData } from '../../Styles/ComponentStyles/formStyles';

const authInstance = axios.create({
    baseURL: 'http://154.61.173.102:3006',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
});

const transactionAddEffect = (formData) => {

    const token = getDecryptedData("accessToken");
    return new Promise((resolve, reject) => {
      authInstance.request({
        url: `/sales/addsale`,
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Bearer ${token}`,
        },
      })
      .then(response => {

        resolve(response);
      })
      .catch(error => {
        reject(handleApiError(error))
      });
    });
  };
  
  const transactionUpdateEffect = (id, formData) => {
    const token = getDecryptedData("accessToken");
    return new Promise((resolve, reject) => {
      authInstance.request({
        url: `/vendors/convertToTransaction/${id}`,
        method: 'PUT',
        data: formData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Bearer ${token}`,
        },
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(handleApiError(error))
      });
    });
  };
  
  const transactionViewEffect = (pageNo) => {
    const token = getDecryptedData("accessToken");
    return new Promise((resolve, reject) => {
      authInstance.request({
        url: `/transactions/list?pagination_required=false&pageNo=${pageNo}&pagesize=10`,
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(handleApiError(error))
      });
    });
  };
  
  const transactionParticularViewEffect = (id) => {


    const token = getDecryptedData("accessToken");

    return new Promise((resolve, reject) => {
      authInstance.request({
        url: `/transactions/gettransactionbyvendor?vendor_id=${id}`,
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(handleApiError(error))
      });
    });
  };
  const transactionCustomerParticularViewEffect = (id) => {
    
    const token = getDecryptedData("accessToken");

    return new Promise((resolve, reject) => {
      authInstance.request({
        url: `/transactions/gettransactionbyvendor?vendor_id=${id}`,
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(handleApiError(error))
      });
    });
  };
    
  const CustomerTransactionParticularViewEffect = (id) => {

    const token = getDecryptedData("accessToken");

    return new Promise((resolve, reject) => {
      authInstance.request({
        url: `/transactions/gettransactionbycustomer?customer_id=${id}`,
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(handleApiError(error))
      });
    });
  };
  
  const transactionDeleteEffect = (id) => {
    const token = getDecryptedData("accessToken");
    return new Promise((resolve, reject) => {
      authInstance.request({
        url: `/vendors/convertToTransaction/${id}`,
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(handleApiError(error))
      });
    });
  };
  
  export {
    transactionAddEffect,
    transactionUpdateEffect,
    transactionDeleteEffect,
    transactionViewEffect,
    transactionParticularViewEffect,
    CustomerTransactionParticularViewEffect,
    transactionCustomerParticularViewEffect
  }